export default class EditOrgUserViewModel {
    public id: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public roleId: string = '';
    public organisationId: string = '';
    public siteId: string = '';
}
